import React, { useEffect, useState } from 'react'
import style from '../bankDetails/bankDetails.module.css';
import axios from 'axios';
import { ErrorToast, SuccessToast } from '../../../components/toastMessage';
import { BASE_URL } from '../../../constants/Constants';
import styles from "../../verificationPage/verifcation.module.css";
import { FileUploader } from 'react-drag-drop-files';
import uploadFileToBlob from "../../../utils/azure-storage-blob";
import { useNavigate } from 'react-router-dom';
import BoxComponent from '../../../components/CommonComponents/BoxComponent/BoxComponent';
import { _axios } from '../../../utils/axios';

interface AutoFillFieldsState {
    municipal_council_name: string;
    tahasil_name: string;
    district_name: string;
    demand_note_header_text: string;
    certificate_header_text: string;
    demand_note_logo: any;
    certificate_logo: any;
}

const AutoFillFieldsData = () => {
    const navigate = useNavigate();

    const fileTypes = ["JPG", "PNG", "JPEG"];
    const [formFields, setFormFields] = useState<AutoFillFieldsState>({
        municipal_council_name: "",
        tahasil_name: "",
        district_name: "",
        demand_note_header_text: "",
        certificate_header_text: "",
        demand_note_logo: "",
        certificate_logo: ""
    });

    const fetchData = async () => {
        const response = await _axios.get(`${BASE_URL}/api/controller/auto-fill`)
        if (response?.data?.success === 0) {
            ErrorToast(response?.data?.message)
            return
        }
        const data = response?.data?.data[0];
        setFormFields({
            municipal_council_name: data?.municipal_council_name ?? '',
            tahasil_name: data?.tahasil_name ?? '',
            district_name: data?.district_name ?? '',
            demand_note_header_text: data?.demand_note_header_text ?? '',
            certificate_header_text: data?.certificate_header_text ?? '',
            demand_note_logo: data?.demand_note_logo ?? '',
            certificate_logo: data?.certificate_logo ?? ''
        });

    };

    useEffect(() => { fetchData() }, []);

    const handleChange = (event: { target: { name: any; value: any } }) => {
        const { name, value } = event.target;
        setFormFields({ ...formFields, [name]: value });
    };

    // Function to handle form submission
    // const handleSubmit = async (event: { preventDefault: () => void }) => {
    //     event.preventDefault();
    //     const response = await axios.patch(`${BASE_URL}/api/controller/auto-fill`, formFields);
    //     if (response?.data?.success === 0) {
    //         ErrorToast(response?.data?.message || 'Something went wrong!')
    //         return
    //     }
    //     SuccessToast(response?.data?.message)
    // };
    const handleSubmit = async (event: { preventDefault: () => void }) => {
        event.preventDefault();

        // Check if mandatory fields are filled
        if (!formFields.municipal_council_name || !formFields.tahasil_name || !formFields.district_name) {
            ErrorToast('All fields are mandatory');
            return;
        }

        const response = await _axios.patch(`${BASE_URL}/api/controller/auto-fill`, formFields);
        if (response?.data?.success === 0) {
            ErrorToast(response?.data?.message || 'Something went wrong!')
            return
        }
        SuccessToast(response?.data?.message)
    };

    return (
        <div>
            <div>
                <div className={`${style.body} p-8`}>
                    <p className={style.bodyTitleNormal}>Auto Fill Demand Note / Certificate Fields</p>
                    <BoxComponent>
                        <div className={style.bodyContanier}>
                            <div className={style.logoUploadContainer}>
                                <div className={style.uploadsection}>
                                    <div className="appIdForm">
                                        {/* <p className={style.bodyTitleNormal}>Auto Fill Demand Note / Certificate Fields</p> */}
                                        <form
                                            onSubmit={handleSubmit}
                                        >
                                            <div className={style.formRow}>
                                                <div className={style.formGroup}>
                                                    <label className={style.subHeadingLabel}>
                                                        Municipal Council Name <span className="ml-1 text-danger"> *</span>
                                                    </label>
                                                    <input
                                                        className={style.InputTxtNum}
                                                        type="text"
                                                        name="municipal_council_name"
                                                        placeholder='Enter Municipal Council Name'
                                                        value={formFields.municipal_council_name}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <div className={style.formGroup}>
                                                    <label className={style.subHeadingLabel}>Tehsil Name
                                                        <span className="ml-1 text-danger"> *</span>
                                                    </label>
                                                    <div className={style.passwordContainer}>
                                                        <input
                                                            className={style.InputTxtNum}
                                                            type="text"
                                                            name="tahasil_name"
                                                            placeholder='Enter Tehsil Name'
                                                            value={formFields.tahasil_name}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </div>

                                            </div>
                                            <div className={style.formRow}>
                                                <div className={style.formGroup}>
                                                    <label className={style.subHeadingLabel}>District Name
                                                        <span className="ml-1 text-danger"> *</span>
                                                    </label>
                                                    <div className={style.passwordContainer}>
                                                        <input
                                                            className={style.InputTxtNum}
                                                            type="text"
                                                            name="district_name"
                                                            placeholder='Enter District Name'
                                                            value={formFields.district_name}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </div>
                                                <div className={style.formGroup}></div>
                                            </div>
                                            <div className={style.buttonSection}>
                                                {/* <button type='submit' className={'bg-primary px-10 py-2 rounded-full font-bold text-white disabled:bg-gray-300 disabled:text-gray-500 mb-10'}>
                                                Publish
                                            </button> */}

                                                <button className="bg-primary ml-4 px-6 py-2 font-bold text-white
                                             rounded-full disabled:bg-gray-300">Create</button>

                                                <button className="bg-black ml-4 px-6 py-2 font-bold text-white rounded-full disabled:bg-gray-300" onClick={() => navigate('/dashboard')}>Close</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </BoxComponent>
                </div>
            </div>
        </div>
    )
}

export default AutoFillFieldsData;

